<template>
  <div class="liangdain">
    <h2>{{ data['fileTitle' + En] }}</h2>
    <div class="small-title">
      <span>时间：{{ data.releaseTime }}</span><span>来源：{{ data.fileSource }}</span>
    </div>
    <div class="liangdian-content vhtml" v-html="data['content' + En]"></div>
  </div>
</template>

<script>
import protal from "@/api/protal";
export default {
  name: 'liangdain',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .liangdain {
    h2 {
      font-size: .26rem;
      color: #3E3A39;
    }

    .small-title {
      display: flex;
      font-size: .18rem;
      line-height: 1;
      color: #736B69;
      margin: .2rem 0;

      span {
        margin-right: .2rem;
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .liangdain {
    h2 {
      font-size: .3rem;
      line-height: .44rem;
      color: #3E3A39;
    }

    .small-title {
      display: flex;
      font-size: .24rem;
      line-height: .36rem;
      color: #736B69;
      margin: .2rem 0;

      span {
        margin-right: .2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/wangjie/jieshao.vue